import * as service from './service'
export default {
  namespace: 'recommendUserActivityRule',
  state: {
    demoData: {}
  },
  effects: {
    * getActivityDetail ({ payload }, { call, put }) {
      const res = yield call(service.getActivityDetail, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
